import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { ScrollArea } from '../components/ui/scroll-area';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import { X, FileText, User, Building2, MapPin, Calendar, Briefcase } from 'lucide-react';

export const ResumeViewerModal = ({ isOpen, onClose, candidate }) => {
  if (!candidate) return null;
  
  const parsed = candidate.parsed_data || {};
  const rawText = candidate.raw_text || 'Resume content not available';
  
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[85vh] p-0" data-testid="resume-viewer-modal">
        <DialogHeader className="p-4 pb-2 border-b">
          <div className="flex items-center justify-between">
            <DialogTitle className="flex items-center gap-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
              <FileText className="h-5 w-5 text-primary" strokeWidth={1.5} />
              Resume: {parsed.name || 'Unknown Candidate'}
            </DialogTitle>
          </div>
          
          {/* Quick Info Bar */}
          <div className="flex flex-wrap items-center gap-3 mt-2 text-sm text-muted-foreground">
            {parsed.experience_years && (
              <span className="flex items-center gap-1">
                <Calendar className="h-3.5 w-3.5" /> {parsed.experience_years} years
              </span>
            )}
            {parsed.current_company && (
              <span className="flex items-center gap-1">
                <Building2 className="h-3.5 w-3.5" /> {parsed.current_company}
              </span>
            )}
            {parsed.location && (
              <span className="flex items-center gap-1">
                <MapPin className="h-3.5 w-3.5" /> {parsed.location}
              </span>
            )}
          </div>
          
          {/* Skills */}
          {parsed.skills && parsed.skills.length > 0 && (
            <div className="flex flex-wrap gap-1 mt-3">
              {parsed.skills.slice(0, 12).map((skill, idx) => (
                <Badge key={idx} variant="secondary" className="text-xs">
                  {skill}
                </Badge>
              ))}
              {parsed.skills.length > 12 && (
                <Badge variant="outline" className="text-xs">
                  +{parsed.skills.length - 12} more
                </Badge>
              )}
            </div>
          )}
        </DialogHeader>
        
        <ScrollArea className="h-[500px] p-4">
          <div className="prose prose-sm dark:prose-invert max-w-none">
            <pre className="whitespace-pre-wrap font-sans text-sm leading-relaxed bg-muted/30 p-4 rounded-lg">
              {rawText}
            </pre>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default ResumeViewerModal;
